module.exports = __webpack_public_path__ + "img/qy (15).654ee6b2.jpg";